import { UENameToIdMap } from '../../constants/unifiedEventTypeIds';
import ApprovalUnifiedEventCreated from './ApprovalUnifiedEventCreated';
import ApprovalUnifiedEventStepApproved from './ApprovalUnifiedEventStepApproved';
import ApprovalUnifiedEventUpdated from './ApprovalUnifiedEventUpdated';
import ApprovalUnifiedEventCanceled from './ApprovalUnifiedEventCanceled';
import ApprovalUnifiedEventApproved from './ApprovalUnifiedEventApproved';
import ApprovalUnifiedEventConcluded from './ApprovalUnifiedEventConcluded';
import ApprovalUnifiedEventStepRejected from './ApprovalUnifiedEventStepRejected';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ApprovalUnifiedEventDisplay(props) {
  const {
    event
  } = props;
  const eventTypeId = event.eventTypeId.innerId;
  switch (eventTypeId) {
    case UENameToIdMap.UE_APPROVAL_CREATED:
      return /*#__PURE__*/_jsx(ApprovalUnifiedEventCreated, {
        event: event
      });
    case UENameToIdMap.UE_APPROVAL_STEP_APPROVED:
      return /*#__PURE__*/_jsx(ApprovalUnifiedEventStepApproved, {
        event: event
      });
    case UENameToIdMap.UE_APPROVAL_UPDATED:
      return /*#__PURE__*/_jsx(ApprovalUnifiedEventUpdated, {
        event: event
      });
    case UENameToIdMap.UE_APPROVAL_CANCELED:
      return /*#__PURE__*/_jsx(ApprovalUnifiedEventCanceled, {
        event: event
      });
    case UENameToIdMap.UE_APPROVAL_APPROVED:
      return /*#__PURE__*/_jsx(ApprovalUnifiedEventApproved, {
        event: event
      });
    case UENameToIdMap.UE_APPROVAL_CONCLUDED:
      return /*#__PURE__*/_jsx(ApprovalUnifiedEventConcluded, {
        event: event
      });
    case UENameToIdMap.UE_APPROVAL_REJECTED:
      return /*#__PURE__*/_jsx(ApprovalUnifiedEventStepRejected, {
        event: event
      });
    default:
      return /*#__PURE__*/_jsx(_Fragment, {});
  }
}